const axiosInstance = require('axios').create({
     // baseURL: 'http://localhost:5000/',
     baseURL: '/',
     // timeout: 1000,
     headers: { "Authorization" : `Bearer ${document.cookie ? (document.cookie.split("=").length >= 2 ? document.cookie.split("=")[1] : "") : ""}` }
});
export default axiosInstance;